module.exports = __webpack_public_path__ + "media/usecase_enterprise_04.cb0555c5.mp4";